import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';

import { Document as IDocument } from '../interfaces';
import css from '../css/document.m.css';

export interface DocumentProperties extends IDocument {}

@theme(css)
export class Document extends I18nThemed<DocumentProperties> {
	protected render(): DNode {
		const { title, text, id } = this.properties;
		return v('div', { classes: [this.theme(css.root)], id }, [
			v('h1', { classes: [this.theme(css.heading)] }, [title]),
			v('article', { classes: [this.theme(css.article)], innerHTML: text.data })
		]);
	}
}
